import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  useListContext,
  downloadCSV,
  TopToolbar,
  sanitizeListRestProps,
  FunctionField,
} from 'react-admin';
import {
  Card as MuiCard,
  CardContent,
  withStyles,
} from '@material-ui/core';

import {
  Security as SecretIcon,
  DeviceHub as TypeIcon,
  Visibility as VisibilityOnIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@material-ui/icons';

import {
  SearchFilter,
  SelectFilter,
} from './filters';

import CommonPagination from '../Components/paginations';
import {unparse as convertToCSV} from "papaparse";
import {cloneElement} from "react";
import CustomExportButton from "../custom/CustomExportButton";
import EllipsisTextField from "../custom/EllipsisTextField";

const Card = withStyles(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      order: -1,
      width: '15em',
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))(MuiCard);

const FilterSidebar = () => {
  return (
    <Card>
      <CardContent>
        <SearchFilter />
        <SelectFilter label={'Category'} icon={<TypeIcon/>} choices={[
          {value: 'INQUIRY', text: 'Inquiry'},
          {value: 'SMALL_TALK', text: 'Small talk'},
          {value: 'PROMOTE', text: 'Promote'},
          {value: 'ETC', text: 'Etc'},
        ]} source={'typeCode'}/>
        <SelectFilter label={'Status'} icon={<SecretIcon/>} choices={[
          {value: false, text: 'Active'},
          {value: true, text: 'Inactive'},
        ]} source={'isDisable'}/>
      </CardContent>
    </Card>
  );
};

const myExporter = data => {
  const csv = convertToCSV({
    data,
    fields: ['title', 'typeCode', 'createAt', 'progress', 'isSecret', 'isDisable'],
  });
  downloadCSV(csv, 'help');
};

const ListActions = (props) => {
  const {
    className,
    exporter,
    filters,
    maxResults,
    ...rest
  } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    showFilter,
    total,
  } = useListContext();
  return (
          <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: 'button',
            })}
            <CustomExportButton
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={10}
                    exporter={myExporter}
            />
          </TopToolbar>
  );
};

export const CommunityList = props => {
  return (
    <List {...props} title="Community Board"
          aside={<FilterSidebar/>}
          actions={<ListActions/>}
          bulkActionButtons={false}
          pagination={<CommonPagination/>}
          filterDefaultValues={{isDisable: false}}
          sort={{field: 'createAt', order: 'DESC'}}>
      <Datagrid rowClick="edit">
        <EllipsisTextField source="title" label={'Title'} maxLen={30} sortable={false}/>
        <ReferenceField label={'Username'} reference="users" source="writerUserPublicId" sortable={false}>
            <TextField source="displayName" />
        </ReferenceField>
        <DateField source="createAt" showTime label={'Create at'}/>
        <TextField source="typeCode" label={'Category'}/>
        <TextField source="viewCount" label={"Views"}/>
        <TextField source="commentCount" label={"Comments"}/>
        <FunctionField source="commentCount" label="Progress" render={(record, source) => {
          return (record.isDisable === true) ? (
            <span><VisibilityOffIcon color={'error'}/></span>
            ) : (
            <span><VisibilityOnIcon color={'primary'}/></span>
            );
        }}
        />
      </Datagrid>
    </List>
  );
}

export default CommunityList;
